module.exports = __webpack_public_path__ + "static/media/error-icon.3c4a83bf.svg";